import { Outside } from '@cian/ui-kit';
import { mergeStyles, plural } from '@cian/utils';
import * as React from 'react';

import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterBedrooms.css';

export interface IFilterBedroomsProps {
  value: number | null;
  onChange(bedroomsCount: number): void;
}

export interface IFilterBedroomsState {
  active: boolean;
}

const BEDROOMS_TYPES: { label: string; value: number }[] = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
];

export class FilterBedrooms extends React.Component<IFilterBedroomsProps, IFilterBedroomsState> {
  public state: IFilterBedroomsState = {
    active: false,
  };

  public render() {
    const { value } = this.props;
    const { active } = this.state;

    const bedroomsLabel = (value && `от ${value} ${plural(value, ['спальни', 'спален', 'спален'])}`) || null;

    return (
      <Outside onOutside={this.handleOutsideClick}>
        <div {...mergeStyles(stylesCommon['container'], styles['container'])} data-mark="FilterBedrooms">
          <button
            {...mergeStyles(
              stylesCommon['button'],
              active && stylesCommon['button--active'],
              !bedroomsLabel && stylesCommon['button--empty'],
            )}
            title={bedroomsLabel || undefined}
            onClick={this.handleButtonClick}
          >
            {bedroomsLabel || 'Спален'}
          </button>
          {active && (
            <div className={styles['dropdown']}>
              <span className={styles['label']}>от</span>
              <ul className={styles['list']}>
                {BEDROOMS_TYPES.map(item => (
                  <li key={`item_${item.label}`}>
                    <button
                      {...mergeStyles(styles['button'], value === item.value && styles['button--active'])}
                      onClick={() => this.handleSelect(item.value)}
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Outside>
    );
  }

  private handleButtonClick = () => {
    this.setState(state => ({
      active: !state.active,
    }));
  };

  private handleOutsideClick = () => {
    this.setState({
      active: false,
    });
  };

  private handleSelect = (bedroomsCount: number) => {
    this.props.onChange(bedroomsCount);
  };
}
